import SigliveServiceV3 from 'Service/sigliveServiceV3';

const getExportReportHostSummary = async (queries) => {
  const { data } = await SigliveServiceV3({
    method: 'GET',
    url: `/reporting/summary-host/export?${queries}`,
    responseType: 'blob',
  });

  return data;
};

export default getExportReportHostSummary;
